import { Component, Input, inject } from "@angular/core";
import { HssTimePipe } from "../pipes/hss-time.pipe";
import { HssDurationPipe } from "../pipes/hss-duration";
import { Hss } from "../models/hss";
import { HssBuilderService } from "../hss-builder.service";

@Component({
  selector: "app-seq-summary",
  standalone: true,
  imports: [HssTimePipe, HssDurationPipe],
  templateUrl: "./seq-summary.component.html",
  styleUrls: ["./seq-summary.component.scss", "../hss-builder.component.scss"],
})
export class SeqSummaryComponent {
  @Input({ required: true }) hss!: Hss;
  @Input() enhanced?: boolean;
  @Input() index?: number;

  hssBuilderService = inject(HssBuilderService);
}
